import { makeStyles, shorthands } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

const tagPopIn = {
  from: {
    opacity: 0,
    transform: "scale(0.85)",
  },
  to: {
    opacity: 1,
    transform: "scale(1)",
  },
};

export const useStyles = makeStyles({
  tag: {
    "--colorBrandBackground2": designTokens.accent[500],
    color: designTokens.neutral.white,
    maxWidth: "280px",
    "@media (max-width: 640px)": {
      maxWidth: "200px",
    },
    display: "inline-flex",
    alignItems: "center",
    animationName: tagPopIn,
    animationDuration: designTokens.transition.fast,
    animationFillMode: "both",
    transition: `all ${designTokens.transition.fast}`,
    "& > span": {
      display: "inline-flex",
      alignItems: "center",
    },
    "& button": {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& svg": {
      display: "block",
    },
    ":hover": {
      "--colorBrandBackground2": designTokens.accent[600],
      "--colorCompoundBrandForeground1Hover": designTokens.neutral.white,
      color: designTokens.neutral.white,
      cursor: "pointer",
      transform: "scale(1.02)",
    },
  },
  tagText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "150px",
    display: "inline-flex",
    alignItems: "center",
    lineHeight: 1,
  },
  groupRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    ...shorthands.gap(designTokens.spacing[1]),
  },
  groupColumn: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    ...shorthands.gap(designTokens.spacing[1]),
  },
  tagPickerList: {
    maxHeight: "200px",
    overflowY: "auto",
  },
});
